<template>
  <Dialog
    v-model:visible="isVisible"
    header="Confirm new payment amount"
    modal
    :style="{ width: '28rem' }"
    :closable="!isLoading"
  >
    <p class="text-gray-600 mb-4">
      Are you sure you want to change the amount of this payment?
    </p>

    <div class="space-y-1">
      <div class="text-gray-500 line-through">
        {{ formatCurrency(oldAmount) }}
      </div>
      <div class="text-gray-900 font-semibold">
        {{ formatCurrency(newAmount) }}
      </div>
    </div>

    <Divider />

    <div class="flex items-center gap-2">
      <Checkbox v-model="applyToAll" input-id="applyToAll" binary />
      <label for="applyToAll" class="font-medium cursor-pointer">
        Apply to all payments in plan
      </label>
    </div>

    <template #footer>
      <div class="flex justify-end gap-4">
        <Button
          label="Go back"
          text
          severity="secondary"
          :disabled="isLoading"
          @click="emit('go-back')"
        />
        <Button
          label="Confirm New Amount"
          :loading="isLoading"
          @click="emit('confirm')"
        />
      </div>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import Checkbox from "primevue/checkbox";
import Divider from "primevue/divider";
import { getFormattedCurrency } from "@/shared/utils/helpers";

interface Props {
  oldAmount: number | string;
  newAmount: number | string;
  isLoading?: boolean;
}

withDefaults(defineProps<Props>(), { isLoading: false });

const emit = defineEmits<{
  "go-back": [];
  confirm: [];
}>();

const isVisible = defineModel<boolean>("visible", { required: true });
const applyToAll = defineModel<boolean>("applyToAll");

const formatCurrency = (value: number | string) => {
  const num = typeof value === "string" ? parseFloat(value) : value;
  return getFormattedCurrency(Number.isFinite(num) ? num : 0);
};
</script>
